import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=2980f3f2&scoped=true&"
import script from "./FormPreview.vue?vue&type=script&lang=js&"
export * from "./FormPreview.vue?vue&type=script&lang=js&"
import style0 from "./FormPreview.vue?vue&type=style&index=0&id=2980f3f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980f3f2",
  null
  
)

export default component.exports